import type { PropertySearchActions } from './actions';
import type { MapUpdate, SearchTransition } from './intents';
import type { PropertySearchStore } from './store';

import { bindIntents, isSameUrl } from './actions';

// Lab: the store builds the URL through the adapter and performs the only push.
export function createLabSearchActions(
	search: Pick<PropertySearchStore, 'filters' | 'replace' | 'urlFor'>
): PropertySearchActions {
	let pending: { url: string; map: MapUpdate } | undefined;
	function navigate({ filters, map }: SearchTransition) {
		const url = search.urlFor(filters);
		pending = url ? { url, map } : undefined;
		return search.replace(filters);
	}
	return {
		...bindIntents(() => search.filters.value, navigate),
		takeMapUpdate(url) {
			const intent =
				pending && isSameUrl(pending.url, url) ? pending.map : undefined;
			pending = undefined;
			return intent;
		}
	};
}
